import { defineComponent as _defineComponent } from 'vue'
import { ObjectType, SportType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import type { BreadcrumbItem } from '@/features/sports/types/interfaces';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { items: BreadcrumbItem[] };


const route = useRoute();
function routerParams(item: BreadcrumbItem) {
	if (item.routeName) {
		return { name: item.routeName, params: item.routeParams };
	}

	if (item.url) {
		return { path: item.url, params: item.routeParams };
	}
}

function handleLinkClick(item: BreadcrumbItem, index: number) {
	// don't handle link click when it's the last item, and thus active item, in the list
	if (index + 1 === props.items.length) return;

	const contexts = getContextsFromBreadcrumbItem(item);
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'breadcrumb_menu_click',
			useLastRoute: true,
		},
		contexts
	);
}

function getContextsFromBreadcrumbItem(item: BreadcrumbItem) {
	if (item.objectType) {
		const sportType = route.meta?.sport as SportType;
		const sportContext = new SnowplowSportContext(sportType, item.objectType);
		// check for competition objectId
		if (item.objectId && item.objectType === ObjectType.SportCompetition) {
			sportContext.competitionId = item.objectId;
		}
		return [sportContext];
	}
	return undefined;
}

return { __sfc: true,props, route, routerParams, handleLinkClick, getContextsFromBreadcrumbItem }
}

})